/**
 * Choix de la SKILLCARD de fond d'un défi (migration 0699) : sans choix, le
 * défi prend la SKILLCARD reliée à sa question.
 */
import { SkillcardPickerField } from '@/features/skillcards/skillcard-picker';
import {
  backgroundSections,
  useChallengeBackgroundOptions,
} from '@/lib/challenges/challenge-background';

export function ChallengeBackgroundPicker({
  exerciseId,
  value,
  onChange,
  disabled,
}: {
  exerciseId: string;
  value: string | null;
  onChange: (cardId: string | null) => void;
  disabled?: boolean;
}) {
  const { data, isLoading, error } = useChallengeBackgroundOptions(exerciseId);
  const items = data?.items ?? [];
  return (
    <div>
      <SkillcardPickerField
        label="Fond du défi"
        title="Fond du défi"
        items={items}
        sections={data ? backgroundSections(data) : undefined}
        value={value}
        onChange={onChange}
        noneLabel="La SKILLCARD de la question (automatique)"
        disabled={disabled || isLoading}
      />
      <p className="text-ink-500 mt-1 font-sans text-xs">
        {error
          ? 'Les SKILLCARDS n’ont pas pu être chargées.'
          : 'Sans photo ni vidéo, le défi prend la couleur et la créature de cette SKILLCARD.'}
      </p>
    </div>
  );
}
